import { EditOutlined } from '@ant-design/icons';

import { Category, Document } from 'interfaces/documents';
import { useModal } from 'hooks/useModal';
import { renameCategory } from 'slices/categoriesActions';
import { renameDocument, refreshDocumentTreeLevels } from 'slices/documentsActions';
import { useAppDispatch } from 'utilities/hooks';
import { MenuItemType } from 'antd/es/menu/interface';

export const Rename = (
    row: Category | Document,
    fetchData: () => void
): MenuItemType => {
    const dispatch = useAppDispatch();
    const { openModal } = useModal();

    const rename = async (item: string) => {
        if (row?.type === 'category') {
            await dispatch(renameCategory({ id: (row as Category).uuid, name: item })).unwrap();
            dispatch(refreshDocumentTreeLevels([(row as Category).id]));
        } else {
            await dispatch(renameDocument({ id: (row as Document).id, name: item })).unwrap();
        }
        fetchData();
    };

    return {
        key: 'Rename',
        label: 'Rename',
        onClick: () => {
            openModal('renameModal', {
                entity: row,
            }, {
                onSubmit: (value: string) => {
                    if (value) {
                        rename(value);
                    }
                },
            });
        },
        icon: <EditOutlined />,
    };
};